import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class TemperatureData{
    static attributePrefix = "Temperature";
    static attributePrefixDe = "Temperatur";
}